import React, { useRef, useEffect } from "react";
import ApexCharts from "apexcharts";

const RecognitionAnalyticsChart = ({ daily, labels }) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    if (!chartRef.current || !daily || daily.length === 0) return;

    const options = {
      chart: {
        type: "bar",
        height: 350,
        toolbar: { show: false },
        fontFamily: "'Signal Plex', sans-serif",
      },
      series: [
        {
          name: labels.successRate,
          data: daily.map((d) => d.successRate || d.success_rate),
        },
      ],
      plotOptions: {
        bar: {
          borderRadius: 0,
          columnWidth: "60%",
        },
      },
      dataLabels: { enabled: false },
      colors: ["#718b11"],
      states: {
        hover: {
          filter: {
            type: "lighten",
            value: 0.15,
          },
        },
        active: {
          filter: {
            type: "lighten",
            value: 0.2,
          },
        },
      },
      xaxis: {
        categories: daily.map((d) => d.day),
        labels: { style: { fontSize: "12px" } },
      },
      yaxis: {
        min: 0,
        max: 100,
        labels: {
          formatter: (val) => val + "%",
          style: { fontSize: "12px" },
        },
      },
      grid: {
        borderColor: "#e7e7e7",
        strokeDashArray: 4,
      },
      tooltip: {
        custom: function ({ dataPointIndex }) {
          var d = daily[dataPointIndex];
          if (!d) return "";
          return (
            '<div class="signal-chart-tooltip">' +
            '<div class="signal-chart-tooltip-title">' + d.day + "</div>" +
            '<div>' + labels.successRate + ": <b>" + (d.successRate || d.success_rate) + "%</b></div>" +
            '<div>' + labels.total + ": <b>" + d.total + "</b></div>" +
            '<div class="signal-chart-success">' + labels.successful + ": <b>" + d.successful + "</b></div>" +
            '<div class="signal-chart-warning">' + labels.corrected + ": <b>" + d.corrected + "</b></div>" +
            "</div>"
          );
        },
      },
    };

    chartInstance.current = new ApexCharts(chartRef.current, options);
    const updateTheme = () => {
      const styles = getComputedStyle(document.documentElement);
      const dark = document.documentElement.dataset.signalTheme === "dark";
      chartInstance.current.updateOptions({
        colors: [dark ? "#dfff42" : "#718b11"],
        chart: { foreColor: styles.getPropertyValue("--sg-text").trim() },
        grid: { borderColor: styles.getPropertyValue("--sg-rule").trim() },
      }, false, false);
    };
    let mounted = true;
    chartInstance.current.render().then(() => { if (mounted) updateTheme(); });
    window.addEventListener("pharmiq:themechange", updateTheme);

    return () => {
      mounted = false;
      window.removeEventListener("pharmiq:themechange", updateTheme);
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [daily, labels]);

  return <div ref={chartRef} />;
};

export default RecognitionAnalyticsChart;
